
import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { getProductList, getSubProductList } from '@/api/product/product'
import {
  getProductAccountList,
  newProductAccount
} from '@/api/product/productAccount'
import { test } from '@/api/test'
import { testRules } from '@/utils/rules'
import { getBnakList, getEnterprise } from '@/api/universal'
import { AppModule } from '@/store/modules/app'
import { getMerchant } from '@/api/merchant/merchant'
import { getType } from '@/utils/cookies'
import { getSubProductBankCode } from '../../api/product/product'

@Component({
  name: 'test',
  components: {}
})
export default class extends Vue {
  private form: any = {
    merchant: null,
    product: null,
    product_account: null,
    amount: null,
    extra: {},
    id: null,
    product_sub: ''
  }
  private rules = testRules
  private productList: any[] = [] // 产品
  private subProductList: any = []
  private accountList: any[] = []
  private merchantList: any[] = []
  private loading: boolean = false
  private bankList: any[] = []
  private merchant: any = ''
  private subProductExtra: any = {}
  private subProductExtraFields: any = {}
  private subProductBank: any = []
  get extraList() {
    let arr = this.productList.filter(item => {
      return item.id === this.form.id
    })
    return arr
  }

  // 选择商户操作
  private selMerchant(val) {
    this.form.merchant = val
    this.form.product = null
    this.accountList = []
    if (this.sysType === 'ant') {
      this.arr = []
      this.form.product_account = null
      this.productAccountList = []
    }
    this.getProductList()
  }

  // 选择产品操作
  private async selProduct(val) {
    this.form.id = val
    this.form.extra = {}
    this.form.product_account = null
    this.arr = []
    this.productAccountList = []
    this.antAccountList = []
    // this.accountList = []
    this.form.product_sub = ''
    await this.getBnakList()
    if (this.sysType === 'payment') {
      await this.getAccountList()
    }
    await this.getSubProduct()
  }

  // 选择子产品
  private async selSubProduct(val) {
    const selectedSubProduct = this.subProductList.find(
      (item: any) => item.sub_product_id === val
    )
    this.subProductExtra = selectedSubProduct
    this.getSubBankCode()
  }

  // 获取子产品银行code
  private async getSubBankCode() {
    const data = {
      parent_product_id: this.form.product,
      sub_product_id: this.form.product_sub
    }
    await getSubProductBankCode(data).then((res: any) => {
      this.subProductBank = res
    })
  }

  // 获取平台信息
  private enterpriseInfo: any = {}
  private async getEnterpriseInfo() {
    try {
      await getEnterprise().then((res: any) => {
        this.enterpriseInfo = res
        this.form.merchant = this.enterpriseInfo.test_merchant_no
      })
    } catch (e) {}
  }

  // 获取产品列表
  private async getProductList() {
    const data = {
      merchant: this.form.merchant,
      in_or_out: 1
    }
    await getProductList(data).then((res: any) => {
      this.productList = res
    })
  }

  // 获取子产品列表 getSubProductList
  private async getSubProduct() {
    this.subProductList = []
    const data = {
      merchant_id: this.form.merchant,
      parent_product_id: this.form.product
    }
    await getSubProductList(data).then((res: any) => {
      this.subProductList = res.sub_products
    })
  }

  // 获取产品账户列表
  private async getAccountList() {
    try {
      const params = {
        merchant: this.form.merchant,
        product: this.form.product
      }
      await newProductAccount(params).then((res: any) => {
        this.accountList = res
      })
    } catch (e) {}
  }

  private copyLink: any = ''
  private async test() {
    ;(this.$refs.form as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        try {
          let obj = {}
          for (const key in this.form.extra) {
            obj[key] = this.form.extra[key] !== null ? this.form.extra[key] : ''
          }
          this.form.extra = obj
          await test(this.form).then((res: any) => {
            // let url = res.pay_url.replace('http://checkout-counter.dianmai360.com', 'http://localhost:9001')
            // window.open(url)
            this.copy(res.pay_url)
            setTimeout(() => {
              window.open(res.pay_url)
            }, 200)
            this.loading = false
          })
        } catch (e) {
          this.loading = false
        }
      } else {
        this.loading = false
        return false
      }
    })
  }

  private copy(val) {
    navigator.clipboard.writeText(val).then(() => {
      this.$message.success('Copy successfully')
    })
  }

  // 获取产品银行列表
  private async getBnakList() {
    try {
      const data: any = {
        id: this.form.id
      }
      await getBnakList(data).then((res: any) => {
        this.bankList = res
      })
    } catch (e) {}
  }

  // 获取商户列表
  private async getMerchantList() {
    try {
      const data = {
        page_size: 200
      }
      await getMerchant(data).then((res: any) => {
        this.merchantList = res.results
      })
    } catch (e) {}
  }

  // 远程查询
  private async remoteQuery(query: string) {
    try {
      const data = {
        name: query
      }
      await getMerchant(data).then((res: any) => {
        this.merchantList = res.results
      })
    } catch (e) {}
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.test`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }

  private productAccountList: any = []
  private arr: any = []
  private antAccountList: any = []
  private async remoteMethod(query) {
    if (query !== '') {
      const data: any = {
        name: query,
        product: this.form.product
      }
      await getProductAccountList(data).then((res: any) => {
        this.antAccountList = res.results
        this.antAccountList.forEach(item => {
          this.productAccountList.forEach(el => {
            if (item.id === el.product_account_id) {
              item.ant_state = 0
            }
          })
        })
      })
    }
  }
  private changeArr(val) {
    let indexLen: number = val.length
    val.forEach((item, index, arr) => {
      let itemArr: any = item.split(',')
      let obj: any = {}
      obj.product_account_id = itemArr[0] - 0
      obj.product_account__account_name = itemArr[1]
      obj.product_account__state = itemArr[2] - 0
      obj.product_account__account_type = itemArr[3]
      if (indexLen - 1 === index) {
        this.productAccountList.push(obj)
      }
    })
    const map = new Map()
    this.productAccountList = this.productAccountList.filter(
      v => !map.has(v.product_account_id) && map.set(v.product_account_id, 1)
    )
  }
  private itemArr: any = []
  private removeArr(val) {
    this.itemArr = val.split(',')
    this.productAccountList = this.productAccountList.filter(item => {
      return item.product_account_id !== this.itemArr[0] - 0
    })
  }

  private otherPicture: any = ''
  private sysType: any = ''
  async created() {
    this.sysType = getType()
    await AppModule.GetConstant().then((res: any) => {
      this.otherPicture = res.BANK_UNIVERSAL_ICON
    })
    await this.getMerchantList()
    await this.getEnterpriseInfo()
    await this.getProductList()
  }
}
